import { Directive, HostListener, HostBinding, EventEmitter, Output, Input } from '@angular/core';

@Directive({
  selector: '[itpxDnd]'
})
export class DndDirective {

  @HostBinding('style.background') private background;
  @Output() filesChangeEmiter: EventEmitter<File[]> = new EventEmitter();

  private reader: FileReader = new FileReader();

  constructor() { }

  @HostListener('dragover', ['$event']) public onDragOver(evt){
      evt.preventDefault();
      evt.stopPropagation();
      this.background = '#999';
  }

  @HostListener('dragleave', ['$event']) public onDragLeave(evt){
      evt.preventDefault();
      evt.stopPropagation();
      this.background = '#eee';
  }

  @HostListener('drop', ['$event']) public onDrop(evt){
      evt.preventDefault();
      evt.stopPropagation();
      this.background = '#eee';
      let file = evt.dataTransfer ? evt.dataTransfer.files[0] : evt.target.files[0];
      this.readFile(file);
      if(file){
        this.filesChangeEmiter.emit(file);
      }
  }
  private readFile(file) {
        this.reader.readAsDataURL(file);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/uploader/dnd.directive.ts